import { useCallback } from 'react'

import { AppStore } from '@view/store'
import { fetchInitContext, fetchNavLinks, fetchSecureForm } from '@view/store/features/thunks'

export function useInitApp(store: AppStore): () => void {
	return useCallback(() => {
		store.dispatch(fetchInitContext())
		store.dispatch(fetchNavLinks())
		store.dispatch(fetchSecureForm())
	}, [store])
}
